import Keycloak from "keycloak-js";
import router from "../router";

let initOptions = {
    url: 'https://auth.mytalus.ch',
    realm: 'TOK', clientId: 'tok-frontend',
    onLoad: 'login-required'
}
let keycloak = new Keycloak(initOptions);

class AuthService {
    login() {
        keycloak.init({onLoad: initOptions.onLoad}).catch(() => {
            console.log("Authentication Failed");
            router.push('/');
        });
    }

    logout() {
        const token = localStorage.getItem('idToken');
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('idToken');
        window.location.href = initOptions.url + '/realms/' + initOptions.realm + '/protocol/openid-connect/logout?post_logout_redirect_uri=' + window.location.origin + '&id_token_hint=' + token;
    }
}

export default new AuthService();
